import React, { useState, useCallback } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../ui';
import { mockConsumerComplaints } from '../../utils/mockData';
import ConsumerOverviewTab from './ConsumerOverviewTab';
import ConsumerSurveysTab from './ConsumerSurveysTab';
import ConsumerReputationTab from './ConsumerReputationTab';
import ConsumerComplaintsTab from './ConsumerComplaintsTab';
import ConsumerSignalFeedTab from './ConsumerSignalFeedTab';

function ConsumerInsightsPage({ readOnly = false }) {
  const [activeTab, setActiveTab] = useState('overview');
  const [complaints, setComplaints] = useState(mockConsumerComplaints.all);

  const handleCreateComplaint = useCallback((signal) => {
    const newComplaint = {
      id: `cmp-sig-${Date.now()}`,
      source: 'Email Signal',
      category: signal.category || (signal.classification === 'legal_escalation' ? 'legal_escalation' : 'patient_complaint'),
      urgency: signal.urgency,
      daysOpen: 0,
      owner: null,
      status: 'open',
      subject: signal.title || signal.subject,
      isLegal: signal.urgency === 5,
      estimatedCost: 0,
      unitId: signal.unitId || 'unit-main-st',
      unitName: signal.unitName || 'Main St Clinic',
      notes: [`Created from signal ${signal.id}`],
      createdAt: new Date().toISOString().slice(0, 10),
    };
    setComplaints((prev) => [newComplaint, ...prev]);
  }, []);

  const isOverview = activeTab === 'overview';

  return (
    <div className={isOverview ? 'dashboard-container !overflow-hidden' : 'dashboard-container'}>
      <Tabs
        value={activeTab}
        onValueChange={setActiveTab}
        className={isOverview ? 'flex flex-col flex-1 min-h-0' : undefined}
      >
        <TabsList className="justify-start shrink-0">
          <TabsTrigger value="overview">Overview</TabsTrigger>
          <TabsTrigger value="surveys">Surveys (CAHPS)</TabsTrigger>
          <TabsTrigger value="reputation">Online Reputation</TabsTrigger>
          <TabsTrigger value="complaints">Complaints</TabsTrigger>
          <TabsTrigger value="signals">Signal Feed</TabsTrigger>
        </TabsList>

        <TabsContent value="overview" className={isOverview ? 'flex-1 min-h-0 flex flex-col' : undefined}>
          <ConsumerOverviewTab complaints={complaints} setComplaints={setComplaints} readOnly={readOnly} onCreateComplaint={handleCreateComplaint} />
        </TabsContent>
        <TabsContent value="surveys">
          <ConsumerSurveysTab readOnly={readOnly} />
        </TabsContent>
        <TabsContent value="reputation">
          <ConsumerReputationTab readOnly={readOnly} />
        </TabsContent>
        <TabsContent value="complaints">
          <ConsumerComplaintsTab complaints={complaints} setComplaints={setComplaints} readOnly={readOnly} />
        </TabsContent>
        <TabsContent value="signals">
          <ConsumerSignalFeedTab onCreateComplaint={handleCreateComplaint} readOnly={readOnly} />
        </TabsContent>
      </Tabs>
    </div>
  );
}

export default ConsumerInsightsPage;
